
@if (!hideTitle()) {
  <div class="visual-editor-box__title"
       trgDragHandle
       [dragDirective]="dragDirective()"
       [dragDisabled]="!dragHandleTitle()">
    <div class="visual-editor-box__title-left text-ellipsis">
      @if (canCollapse()) {
        <span class="visual-editor-box__collapse-btn" 
              (mousedown)="$event.stopPropagation()"
              (click)="collapseClick($event)">
          <i class="fas fa-chevron-up"></i>
        </span>
      }
      <span class="visual-editor-box__title-icon" #iconRef [hidden]="!iconRef.children.length">
        <ng-content select="[boxIcon]"></ng-content>
      </span>
      <span class="visual-editor-box__title-text text-ellipsis" #textRef [hidden]="!textRef.children.length">
        <ng-content select="[boxTitle]"></ng-content>
      </span>
    </div>
    <div class="visual-editor-box__title-right">
      <ng-content select="[boxTitleRight]"></ng-content>
      @if (canClose()) {
        <span class="visual-editor-box__close-btn" 
              (mousedown)="$event.stopPropagation()"
              (click)="closeClick($event)">
          <i class="fas fa-times-circle"></i>
        </span>
      }
    </div>
  </div>
}
<div class="visual-editor-box__content" #contentRef
     [hidden]="!contentRef.children.length">
  <ng-content></ng-content>
</div>
<div class="visual-editor-box__collapsedContent" #collapsedContentRef 
     [hidden]="!collapsedContentRef.children.length">
  <ng-content select="[boxCollapsedContent]"></ng-content>
</div>